<div id="notificationDialog">
  <mat-dialog-content>
    <div class="notification-dialog-content-font">
      <span style="white-space: pre-line">{{description}}</span>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button
      class="leave-button"
      mat-stroked-button
      color="accent"
      id="notification-ok-button"
      (click)="leave()">
      {{ 'default.ok' | blah | uppercase }}
    </button>
  </mat-dialog-actions>
</div>